import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-call-notification-info',
  templateUrl: './call-notification-info.component.html',
  styleUrls: ['./call-notification-info.component.scss'],
})
export class CallNotificationInfoComponent implements OnInit {
  public info!: string;
  public title!: string;
  public prefix!: string | undefined;
  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private data: { info: string; title: string; prefix?: string }
  ) {}

  ngOnInit(): void {
    this.info = this.data.info;
    this.title = this.data.title;
    this.prefix = this.data.prefix;
  }

  public confirm() {
    this.dialogRef.close('OK');
  }
}
